import LoadingMixin from "../mixins/loading-mixin";

export default {
    mixins: [LoadingMixin],
    data() {
        return {
            step: 'forgotPassword',
            commonErrors: [],
            errors: [],
            email: ''
        }
    },
    created() {
        this.$store.dispatch('getUserDataByPhone')
            .then((response) => {
                if (response.status === 'success') {
                    this.email = !!response.data.EMAIL ? response.data.EMAIL : ''
                }
            })
            .catch((errors) => {})
    },
    methods: {
        clearErrors() {
            this.commonErrors = []
            this.errors = []
        },
        clearError(fieldName) {
            if (!!this.errors[fieldName]) {
                this.errors[fieldName] = ''
            }
        },
        processErrors(errors) {
            if (errors.length > 0) {
                for (let error of errors) {
                    if (!!error.code) {
                        this.errors[error.code] = error.message
                    } else {
                        this.commonErrors.push(error.message)
                    }
                }
            }
        },
        forgotPassword() {
            this.clearErrors()
            this.startLoader()

            this.$store.dispatch('sendForgotPasswordEmail', this.email)
                .then((response) => {
                    if (response.status === 'success') {
                        this.step = 'sent';
                    }
                })
                .catch((errors) => {
                    this.processErrors(errors)
                })
                .finally(this.stopLoader)
        }
    },
    // language=Vue
    template: `
      <div class="upblock__step">
      <div class="upblock__title">
        <span>{{$Bitrix.Loc.getMessage('JS_MS_AF_PASSWORD_RECOVER')}}</span>
      </div>
      <div class="upblock__body js-val-container">
        <div class="upblock__body-wrapper">
          
          <div class="b-form-field-errors"
               v-if="commonErrors.length > 0"
          >
            <div class="b-form-field-error"
                 v-for="(errorText, i) in commonErrors"
                 :key="i"
            >
              {{errorText}}
            </div>
          </div>
          
          <template v-if="step === 'forgotPassword'">
            <div class="b-form-field">
                <div class="b-form-field__wrapper">
                  <input class="b-form-field__input"
                         type="text"
                         v-model="email"
                         disabled>
                </div>
                <div class="b-form-field-error"
                     v-if="errors['email']">
                  {{errors['email']}}
                </div>
            </div>
            <div class="upblock__body-button js-btn-submit"
                 @click="forgotPassword"
                 v-if="!localLoading"
                 :disabled="localLoading"
            >
              {{$Bitrix.Loc.getMessage('JS_MS_AF_RECOVER')}}
            </div>
            <div class="upblock__body-button js-btn-submit on-load"
                 v-else-if="localLoading"
            >
              {{$Bitrix.Loc.getMessage('JS_MS_AF_WAITING')}}
            </div>
          </template>
          <template v-else>
            <div class="b-form-field">
              <div class="b-form-field-status">
                {{$Bitrix.Loc.getMessage('JS_MS_AF_EMAIL_CODE_SENT')}}
              </div>
            </div>
          </template>
        </div>
      </div>
      </div>
    `
}